import { render, staticRenderFns } from "./PlaylistDetail.vue?vue&type=template&id=482f5986&scoped=true&"
import script from "./PlaylistDetail.vue?vue&type=script&lang=ts&"
export * from "./PlaylistDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f5986",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VOverlay,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482f5986')) {
      api.createRecord('482f5986', component.options)
    } else {
      api.reload('482f5986', component.options)
    }
    module.hot.accept("./PlaylistDetail.vue?vue&type=template&id=482f5986&scoped=true&", function () {
      api.rerender('482f5986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/digitalSignage/PlaylistDetail.vue"
export default component.exports